import { FC, ReactNode } from 'react';

import { styled } from '@mui/material';

import Box, { BoxProps } from '../Box';
import TextListItem from './TextListItem';

export interface TextListProps extends BoxProps {
  children?: ReactNode;
}

type TextList = FC<TextListProps> & {
  Item: typeof TextListItem;
};

const StyledList = styled(Box, {
  name: 'TextList',
  slot: 'Root',
})(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

/**
 * TextList is component based on Typography. You can use colors from Typography and use custom Icon on `TextList.Item`
 */
const TextList: TextList = (props) => {
  return <StyledList {...props} />;
};

TextList.Item = TextListItem;

export default TextList;
